import SwitchHorizontalIcon from '@/components/icons/SwitchHorizontalIcon.vue';
import ChevronSelectorVerticalIcon from '@/components/icons/ChevronSelectorVerticalIcon.vue';
import ChevronUpIcon from '@/components/icons/ChevronUpIcon.vue';
import ChevronDownIcon from '@/components/icons/ChevronDownIcon.vue';
import WrapWithPopover from '@/components/shared/WrapWithPopover.vue';
import { mapState } from "vuex";
export default {
  name: "EvolutionTypeSwitcher",
  emits: ['click', 'sort-direction-change'],
  props: {
    evolutionType: String,
    showSortButton: {
      type: Boolean,
      default: false
    },
    sortState: {
      type: String,
      default: null
    },
    typeButtonDescription: {
      type: Object,
      default: () => ({
        title: '',
        detail: ''
      })
    },
    sortButtonDescription: {
      type: Object,
      default: () => ({
        title: '',
        detail: ''
      })
    },
    sortedButtonDescription: {
      type: Object,
      default: () => ({
        title: '',
        detail: ''
      })
    },
    baseColumnSorted: {
      type: Boolean,
      default: false
    }
  },
  components: {
    SwitchHorizontalIcon,
    ChevronSelectorVerticalIcon,
    ChevronUpIcon,
    ChevronDownIcon,
    WrapWithPopover
  },
  computed: {
    ...mapState({
      currencyConfig: state => state.currency_config.config
    }),
    dynamicSortButtonDescription() {
      const direction = this.sortState === 'asc' ? 'ascending' : this.sortState === 'desc' ? 'descending' : '';
      const baseDesc = direction ? this.sortedButtonDescription : this.sortButtonDescription;
      return {
        ...baseDesc,
        detail: direction ? `${baseDesc.detail} (${direction})` : baseDesc.detail
      };
    }
  },
  methods: {
    toggleSortDirection(e) {
      let nextDirection;
      if (!['asc', 'desc'].includes(this.sortState)) {
        nextDirection = 'desc';
      } else if (this.sortState === 'desc') {
        nextDirection = 'asc';
      } else if (this.sortState === 'asc') {
        nextDirection = 'desc';
      }
      this.$emit('sort-direction-change', nextDirection);
    }
  }
};